<template>
    <div id="service_recall" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">
                        <span id="shopHeader" v-if="$route.params.id > 0">Update Service Recall</span>
                        <span id="shopHeader" v-else>Add Service Recall</span>
                        <button type="submit" class="btn btn-success waves-effect pull-right back-btn-fl" v-on:click.prevent="BackWorkOrderTemplateList">
                               <i class="hi-icon icon-flback"> </i> Back
                        </button>
                    </div>
                    <div class="admin-page-content">
                        <section class="internal-container">
                            <div class="container">
                                <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="WorkOrderTemplateForm">

                                    <div class="form-group">
                                        <div class="col-sm-6">
                                                <label class="control-label required">Asset Type</label>
                                                <v-select class="close-remove" v-model="truckType"  id="truckType" placeholder="Select Asset Type" label="text" :options="vehicleTypeArr" ref="truckType">
                                                </v-select>
                                                <div class="c-error">{{trucktypeerror}}</div>
                                        </div>
                                        <div class="col-sm-6">
                                             <label class="control-label" for="vehicle_manufacturer_id">Manufacturer:</label>
                                                    <v-select v-model="vehicle_manufacturer_id" name="vehicle_manufacturer_id" placeholder="Select Manufacturer."
                                                            label="text"
                                                            :options="manufacturerArr">
                                                    </v-select>
                                            <div class="c-error"></div>
                                        </div>
                                        <div class="clearfix"></div>
                                        <div class="col-sm-2">
                                                <label class="control-label" for="purchase_date">Purchase Date:</label>
                                                    <date-picker placeholder="MM/DD/YYYY" id="purchase_date" name="purchase_date" v-model="purchase_date" :config="options"></date-picker>
                                            <div class="c-error"></div>
                                        </div>
                                        <div class="col-sm-2">
                                                <label class="control-label" for="purchase_date">From Date:</label>
                                                    <date-picker placeholder="MM/DD/YYYY" id="purchase_date" name="purchase_date" v-model="from_date" :config="options"></date-picker>
                                            <div class="c-error"></div>
                                        </div>
                                        <div class="col-sm-2">
                                                <label class="control-label" for="purchase_date">To Date:</label>
                                                    <date-picker placeholder="MM/DD/YYYY" id="purchase_date" name="purchase_date" v-model="to_date" :config="options"></date-picker>
                                            <div class="c-error"></div>
                                        </div>
                                    </div>

                                    <div class="clearfix"></div>

                                    <div class="purchase-charges-deatil-label workorder-template-section"> <p> Template Item </p>
                                        <table aria-describedby="table" class="table">
                                        <thead>
                                        <tr>
                                            <th scope="col">Component</th>
                                            <th scope="col">Task</th>
                                            <th scope="col">Action </th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(template, index) in templateArr" :key="index">
                                            <td>
                                                <v-select v-model="template.item_category_id" name="item_category_id" placeholder="Select Component."
                                                            label="text" class="close-remove"
                                                            :options="componentCategoryArr">
                                                </v-select>
                                                <div class="c-error">{{template.component_error_msg}}</div>
                                            </td>
                                            <td>
                                                <v-select v-model="template.work_order_task_id" name="work_order_task_id" placeholder="Select Task."
                                                            label="text" class="close-remove"
                                                            :options="workOrderTaskArr">
                                                </v-select>
                                                <div class="c-error">{{template.task_error_msg}}</div>
                                            </td>

                                            <td>
                                                <template v-if="templateArr.length != 1">
                                                    <span class="close-row"> <a href="#" v-on:click="removeLine(index)"> × </a></span>
                                                </template>
                                                <template v-else>
                                                    <span class="close-row"> _ </span>
                                                </template>
                                            </td>
                                        </tr>
                                        </tbody>
                                        </table>
                                    </div>

                                    <div class="add-purchase-order-btn basic-form-container">
                                        <button type="submit" v-on:click.prevent="addLine()" class="btn btn-primary btn-lg pull-left">
                                            <i class="hi-icon icon-flAdd"> </i> Add Template Item
                                        </button>
                                    </div>

                                    <div class="form-group">
                                        <div class="alert alert-warning hide col-sm-offset-2 col-sm-6" id="alertError">
                                            <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                            <strong id="errorMsg" class="error"></strong>
                                        </div>
                                    </div>

                                    <div class="col-sm-12 btm-action-btn-fl">
                                        <div class="row">

                                            <button type="submit" id="createTemplateBtn" v-if="$route.params.id > 0" class="btn btn-primary nextBtn btn-lg pull-left" v-on:click.prevent="CreateWOTemplate" >
                                            <i class="hi-icon icon-flUpdate-data"> </i>  Update
                                            </button>

                                            <button type="submit" id="createTemplateBtn" v-else class="btn btn-primary nextBtn btn-lg pull-left" v-on:click.prevent="CreateWOTemplate" >
                                            <i class="hi-icon icon-flSave"> </i>  Save
                                            </button>

                                            <button type="submit" id="createAndContinueTemplateBtn" v-if="$route.params.id == undefined" class="btn btn-primary nextBtn btn-lg pull-left save-continue-btn" v-on:click.prevent="CreateWOTemplate(flag='Save and Continue')" >
                                            <i class="hi-icon icon-flSave-Continue"> </i>  Save and Continue
                                            </button>

                                            <button type="submit" id="cancelTemplateBtn" class="btn btn-primary nextBtn btn-lg pull-left cancel-btn" v-on:click.prevent="BackWorkOrderTemplateList" >
                                            <i class="hi-icon icon-flCancel"> </i>  Cancel
                                            </button>

                                        </div>
                                    </div>

                                </form>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import { contractMixins } from '../mixins/contractMixins';


export default {
  name: "ShopCreate",

  mixins:[commonMixins, contractMixins],
  data: () => ({

    maintenance_type_id: null,
    maintenanceTypeArr: [],
    maintenance_type_error_msg: '',

    componentCategoryArr: [],
    workOrderTaskArr: [],
    templateArr: [],

    loading:false,
    permissions: [],
    cantAccessPage: "",
    vehicleTypeArr:[],
    options: {
        format: 'MM/DD/YYYY',
        useCurrent: false,
    },
    manufacturerArr:[],

  }),
  watch:{
        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_work_order_template') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['vehicleType','component_category','workordertask']);

        self.templateArr.push({
            template_id:0,
            item_category_id: null,
            work_order_task_id: null,

            component_error_msg: "",
            task_error_msg: "",
        })
        self.loadVehicleSearchData();
  },
  methods: {
      loadVehicleSearchData() {

        var self = this;
        $.ajax({
            url: process.env.ROOT_API + "/asset/search",
           type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType: 'json',
            success: function (data) {

                if (data.status == "success") {

                    self.manufacturerArr = data.vehiclemanufacturer;
                    // self.modelArr = data.vehiclemodel;
                    // self.vehicletypeArr = data.vehicletypes;

                }

            },
            error: function (jqXHR, exception) {
                self.Registerbtn = "Register";
                if (jqXHR.status == 0) {
                    self.registerError = "Remote server cannot be reached";
                }
            }
        });
    },

    maintenanceTypeChange(event){
        console.log("type chenged..."+JSON.stringify(event));

        var self = this;
        console.log('evt temp maintenance value => '+event.value)
        console.log('evt temp maintenance text => '+event.text)

        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/workorder/get-workorder-template",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType:"json",
            data:{
                maintenance_id: event.value
            },
            success: function (data) {
                self.loading = false;
                self.templateArr = [];
                if (data.code == 200) {

                    console.log("JSON Response = >" + JSON.stringify(data.content))

                    for ( var i=0; i<data.content.length; i++ ) {

                        self.templateArr.push({
                            template_id:(data.content[i].template_id != undefined && data.content[i].template_id != null && data.content[i].template_id != '')?data.content[i].template_id:0,
                            item_category_id: (data.content[i].component_category_id != undefined && data.content[i].component_category_id != null && data.content[i].component_category_id != '')?{value: data.content[i].component_category_id, text: self.titleCase(data.content[i].component_category_name + " (" + data.content[i].component_category_code +")")}:null,
                            work_order_task_id: (data.content[i].task_id != undefined && data.content[i].task_id != null && data.content[i].task_id != '')?{value: data.content[i].task_id, text: self.titleCase(data.content[i].task_name + " (" + data.content[i].task_code +")")}:null,

                            task_error_msg: "",
                            component_error_msg: ""
                        })

                    }

                }else if(data.code = 201){

                    self.templateArr.push({
                        template_id:0,
                        item_category_id: null,
                        work_order_task_id: null,

                        component_error_msg: "",
                        task_error_msg: "",
                    })

                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.Registerbtn = "Register";
                if (jqXHR.status == 0) {
                    self.error = "Remote server cannot be reached";
                } else {
                //redirect to login page if user not authenticated
                if (jqXHR.status == 401) {
                    //clear previous data
                    localStorage.removeItem("user_obj");
                    localStorage.removeItem("tkn");

                    self.$router.push("/");
                }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });

    },

    BackWorkOrderTemplateList() {
      var self = this;
      self.$router.push("/workordertemplate/list");
    },

    CreateWOTemplate(flag) {

        var self = this;
        var error = false;

        self.maintenance_type_error_msg = "";


        if (!self.maintenance_type_id || self.maintenance_type_id == null || self.maintenance_type_id == "") {
            self.maintenance_type_error_msg = "Maintenance Type Required.";
            error = true;
        }

        for (var i=0; i<self.templateArr.length; i++) {

            self.templateArr[i].component_error_msg = "";
            self.templateArr[i].task_error_msg = "";

            if (self.templateArr[i].work_order_task_id == null || self.templateArr[i].work_order_task_id == "" || self.templateArr[i].work_order_task_id == 0) {
                self.templateArr[i].task_error_msg = "Task Required.";
                error = true;
            }

            if (self.templateArr[i].item_category_id == null || self.templateArr[i].item_category_id == "" || self.templateArr[i].item_category_id == 0) {
                self.templateArr[i].component_error_msg = "Component Required.";
                error = true;
            }



        }

      if (!error) {

            // PR - For Template Item
            var templateIdsArr = [];
            var componentArr = [];
            var taskArr = [];

            // alert('Array length..'+self.chargesArr.length);
            for (var i = 0; i<self.templateArr.length;i++) {

                templateIdsArr.push(self.templateArr[i].template_id);
                componentArr.push(self.templateArr[i].item_category_id.value);
                taskArr.push(self.templateArr[i].work_order_task_id.value);

            }

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createTemplateBtn").val("Updating ...");
                $("#createTemplateBtn").prop("disabled", true);
                $("#cancelTemplateBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueTemplateBtn").val("Saving ...");
                    $("#createTemplateBtn").prop("disabled", true);
                    $("#createAndContinueTemplateBtn").prop("disabled", true);
                    $("#cancelTemplateBtn").prop("disabled",true);

                }else{

                    $("#createTemplateBtn").val("Saving ...");
                    $("#createTemplateBtn").prop("disabled", true);
                    $("#createAndContinueTemplateBtn").prop("disabled", true);
                    $("#cancelTemplateBtn").prop("disabled",true);
                }

            }

            var fields = $("#WorkOrderTemplateForm").serializeArray();
            fields.push({name: "templateIdsArr", value: templateIdsArr});
            fields.push({name: "componentArr", value: componentArr});
            fields.push({name: "taskArr", value: taskArr});
            fields.push({ name: "id", value: segments[3] });
            fields.push({name: "maintenance_type_id", value: self.maintenance_type_id.value});

            $.ajax({
                url: process.env.ROOT_API + "/workordertemplate/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createTemplateBtn").val("Update");
                        $("#createTemplateBtn").prop("disabled", false);
                        $("#cancelTemplateBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueTemplateBtn").val("Save and Continue");
                            $("#createTemplateBtn").prop("disabled", false);
                            $("#createAndContinueTemplateBtn").prop("disabled", false);
                            $("#cancelTemplateBtn").prop("disabled",false);

                        }else{

                            $("#createTemplateBtn").val("Save");
                            $("#createTemplateBtn").prop("disabled", false);
                            $("#createAndContinueTemplateBtn").prop("disabled", false);
                            $("#cancelTemplateBtn").prop("disabled",false);
                        }

                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            self.maintenance_type_id = null;
                            self.templateArr = [];
                            self.templateArr.push({
                                template_id:0,
                                item_category_id: null,
                                work_order_task_id: null,

                                task_error_msg: "",
                                component_error_msg: ""
                            })

                        }else{
                            self.$router.push("/workordertemplate/list");
                        }

                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createTemplateBtn").val("Update");
                        $("#createTemplateBtn").prop("disabled", false);
                        $("#cancelTemplateBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            self.name = "";
                            $("#createAndContinueTemplateBtn").val("Save and Continue");
                            $("#createTemplateBtn").prop("disabled", false);
                            $("#createAndContinueTemplateBtn").prop("disabled", false);
                            $("#cancelTemplateBtn").prop("disabled",false);

                        }else{

                            $("#createTemplateBtn").val("Save");
                            $("#createTemplateBtn").prop("disabled", false);
                            $("#createAndContinueTemplateBtn").prop("disabled", false);
                            $("#cancelTemplateBtn").prop("disabled",false);

                        }
                    }
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");

                            self.$router.push("/");
                        }
                        $("#errorMsg").html(jqXHR.responseJSON.message);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            });
      }
    },

    loadWOTemplate() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/workordertemplate/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {

                    self.code = data.content.code;
                    self.name = data.content.name;
                    if(data.content.location_id == null){
                        self.location_id = null;
                    }else{
                        self.location_id = {value: data.content.location_id, text: self.titleCase(data.content.company_name)};
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");

                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },

    addLine () {

        var self = this;

        var index=self.templateArr.length-1;
        self.templateArr[index].task_error_msg = "";
        self.templateArr[index].component_error_msg = "";

        console.log('self.templateArr -> '+JSON.stringify(self.templateArr));

        if ( self.templateArr[index].item_category_id != null && self.templateArr[index].work_order_task_id != null ) {

            self.templateArr.push({
                template_id:0,
                item_category_id: null,
                work_order_task_id: null,

                task_error_msg: "",
                component_error_msg: ""
            })

        } else {

            if (self.templateArr[index].item_category_id == null || self.templateArr[index].item_category_id == "" ) {
                self.templateArr[index].component_error_msg = "Component Required.";
            }

            if (self.templateArr[index].work_order_task_id == null || self.templateArr[index].work_order_task_id == "") {
                self.templateArr[index].task_error_msg = "Task Required.";
            }

        }

    },

    removeLine (index) {

        var self = this;

        if (self.templateArr[index].template_id == 0) {
            self.templateArr.splice(index, 1);

        }
        else {

            if (confirm('Are you sure that you want to remove this? ')) {

                $.ajax({
                    url: process.env.ROOT_API + "/workordertemplate/remove-item",
                    type: "POST",
                    data: {'id': self.templateArr[index].template_id},
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        if (data.status == "success") {
                            self.templateArr.splice(index, 1);
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (jqXHR.status == 0) {
                            self.errorMsg = "Remote server cannot be reached";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("tkn");

                                self.$router.push("/");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }

                    },
                });
            }

        }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ServiceRecallCreate.vue